// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__31aoB","addWidgetButton":"Header_addWidgetButton__3gkzA","dashboardTabs":"Header_dashboardTabs__1auUz","active":"Header_active__1pZjy"};